<template>
  <div>
    <!--banners></!--banners-->
    <div id="whitelabel">
      <PromocoesHome></PromocoesHome>
    </div>
  </div>
</template>
<script>
//import banners from './componentes/banners.vue';
import PromocoesHome from './componentes/PromocoesHome.vue';

export default {
  name: 'homeWhitelabel',
  bodyClass: 'homeWhitelabel',
  components: {
    // banners,
    PromocoesHome,
  },
};
</script>
<style lang="scss" scoped>
#whitelabel {
  // background: #f0f0f2 !important;
  padding: 1rem !important;
}
</style>
